class PersistentVisibility extends HTMLElement {
  static get observedAttributes() {
    return ["class"]
  }

  connectedCallback() {
    this.restoreVisibility()
  }

  attributeChangedCallback(_attrName, _oldValue, _newValue) {
    const key = this.getStorageKey()

    if (this.classList.contains("hidden")) {
      sessionStorage.setItem(key, "hidden")
    } else {
      sessionStorage.removeItem(key)
    }
  }

  restoreVisibility() {
    const key = this.getStorageKey()
    const visibility = sessionStorage.getItem(key)

    if (visibility == "hidden") {
      this.classList.add("hidden")
    } else {
      this.classList.remove("hidden")
    }
  }

  getStorageKey() {
    let key = this.getAttribute("key")
    key ||= this.id

    if (!key) {
      throw new Error("persistent-visibility requires a key or id attribute")
    }

    return `persistent-visibility:${key}`
  }
}

if (!window.customElements.get("persistent-visibility")) {
  window.PersistentVisibility = PersistentVisibility
  window.customElements.define("persistent-visibility", PersistentVisibility)
}
